<mat-sidenav-container [hasBackdrop]="false">
  <mat-sidenav id="leftSideMenu" mode="side" fixedInViewport="true" [opened]="true" class="dark" [class.thin]="!shouldMenuBeOpened" [disableClose]="true">
    <button id="toggleSideNavBtn" mat-icon-button (click)="toggleSideMenu()" matTooltip="{{ (shouldMenuBeOpened ? 'commons.btn.close' : 'commons.btn.open') | translate }}">
      @if (shouldMenuBeOpened) {
        <mat-icon id="closeSideNavBtnIcon">chevron_left</mat-icon>
      }
      @if (!shouldMenuBeOpened) {
        <mat-icon id="openSideNavBtnIcon">menu</mat-icon>
      }
    </button>
    <header class="side-bar-menu-header" matTooltip="{{ 'dashboard.title' | translate }}">
      @if (shouldMenuBeOpened) {
        <a id="damoLogoLink" appDisabledOffline [hasOfflineNavigationAccess]="hasOfflineNavigationAccess" [routerLink]="['/dashboard']" class="logo">
          <img id="damoLogoImg" alt="Damotech Logo" src="assets/images/Damotech_Logo.png" />
        </a>
      }
      @if (!shouldMenuBeOpened) {
        <a id="damoLogoLinkThin" appDisabledOffline [hasOfflineNavigationAccess]="hasOfflineNavigationAccess" [routerLink]="['/dashboard']" class="logo">
          <img id="damoLogoImgThin" alt="Damotech Logo" src="assets/icons/icon-128x128.png" />
        </a>
      }
    </header>
    <aside class="side-bar-menu">
      <div class="side-bar-menu-items-wrapper">
        <ng-content select=".side-bar-menu-item"></ng-content>
      </div>
    </aside>
    <footer class="side-bar-menu-footer">
      <ng-content select=".side-bar-menu-footer-component"></ng-content>
      @if (userDetails(); as userDetails) {
        <section class="profile-menu-container side-bar-menu-footer-component">
          <button id="profile-menu-btn" appDisabledOffline mat-button [matMenuTriggerFor]="headerProfileMenu">
            <div class="button-body-wrapper" [class.emphasis]="notificationCount || updateAvailable" [matBadge]="getNotificationCount()">
              @if (shouldMenuBeOpened) {
                <mat-icon class="prefix" matTooltip="{{ userDetails.firstName }} {{ userDetails.lastName }}">person</mat-icon>
              } @else {
                <mat-icon [matBadge]="notificationCount + (updateAvailable ? 1 : 0) || null" class="prefix" matTooltip="{{ userDetails.firstName }} {{ userDetails.lastName }}">person</mat-icon>
              }
              @if (shouldMenuBeOpened) {
                <div class="display-infos">
                  <span class="display-name">{{ userDetails.firstName }} {{ userDetails.lastName }}</span>
                  @if (userDetails.organization) {
                    <span class="org">{{ userDetails.organization?.name }}</span>
                  }
                </div>
              }
              @if (shouldMenuBeOpened) {
                <mat-icon class="suffix">chevron_right</mat-icon>
              }
            </div>
          </button>
          <mat-menu id="headerProfileMenu" #headerProfileMenu class="wide">
            <button id="notificationViewBtn" [class.hasNotifications]="notificationCount > 0" mat-menu-item (click)="toggleNotificationCenter()">
              <mat-icon id="notificationViewBtnIcon">notifications</mat-icon>
              <span>{{ 'avian.notification.label' | translate }}</span>
            </button>
            @if (updateAvailable) {
              <button id="updateAppBtn" mat-menu-item (click)="update()">
                <mat-icon id="updateAppBtnIcon">browser_updated</mat-icon>
                <span>{{ 'commons.messages.update.notification' | translate }}</span>
              </button>
            }
            <a mat-menu-item id="profileBtn" [routerLink]="['/stax/users/', userDetails._id]">
              <mat-icon>person</mat-icon>
              <span>{{ 'main.header.options.profile' | translate }}</span>
            </a>
            <a mat-menu-item id="profileOrgBtn" routerLink="/stax/organizations/{{ userDetails.organization?._id }}">
              <mat-icon>device_hub</mat-icon>
              <span>{{ 'main.header.options.organization' | translate }}</span>
            </a>
            <a mat-menu-item id="serviceDeskBtn" rel="noopener noreferrer" [href]="serviceDeskUrl" target="_blank">
              <mat-icon>help</mat-icon>
              <span>{{ 'main.header.options.help' | translate }}</span>
            </a>
            <a mat-menu-item id="faqBtn" rel="noopener noreferrer" [href]="faqUrl()" target="_blank">
              <mat-icon>help_center</mat-icon>
              <span>{{ 'main.header.options.faq' | translate }}</span>
            </a>
            <app-lang-selector></app-lang-selector>
            <a mat-menu-item id="websiteBtn" rel="noopener noreferrer" [href]="websiteUrl">
              <img class="mat-icon" src="assets/icons/icon-72x72.png" [alt]="'main.header.options.website' | translate" />
              <span>{{ 'main.header.options.website' | translate }}</span>
            </a>
            <mat-divider></mat-divider>
            <a mat-menu-item id="logoutBtn" (click)="logout()">
              <mat-icon>exit_to_app</mat-icon>
              <span>{{ 'main.header.options.logout' | translate }}</span>
            </a>
          </mat-menu>
        </section>
      }
    </footer>
  </mat-sidenav>
  @if (displayNotifications) {
    <mat-sidenav
      id="notificationMenu"
      class="previewSideMenu"
      position="end"
      [mode]="notificationsMenuMode"
      [opened]="displayNotifications"
      [disableClose]="true"
      >
      <app-system-notification-center
        [active]="displayNotifications"
        (closeNotificationCenter)="toggleNotificationCenter()"
        [notifications]="notifications"
      ></app-system-notification-center>
    </mat-sidenav>
  }

  @if (mainPreviewTemplateRef && !displayNotifications) {
    <mat-sidenav
      id="previewSideMenu"
      class="previewSideMenu"
      position="end"
      [opened]="shouldShowPreviewPane()"
      mode="side"
      (opened)="updateMenuState()"
      >
      @if (!previewMenuAlwaysOpen) {
        <header>
          <button id="closeSidePreviewBtn" mat-icon-button (click)="togglePreviewMenu()" matTooltip="{{ 'commons.btn.close' | translate }}">
            <em id="closeSidePreviewBtnIcon" class="material-icons">chevron_right</em>
          </button>
        </header>
      }
      <section class="main-preview-wrapper">
        <ng-container *ngTemplateOutlet="mainPreviewTemplateRef"></ng-container>
      </section>
    </mat-sidenav>
  }

  <mat-sidenav-content [style.margin-left]="shouldMenuBeOpened ? '300px' : '70px'">
    <section class="app-main-content" id="sidenavContent">
      <mat-toolbar class="main-toolbar" id="mainToolbar">
        <mat-toolbar-row class="actions">
          <ng-content select=".actions-toolbar"></ng-content>
        </mat-toolbar-row>
      </mat-toolbar>

      <section class="main-wrapper">
        <app-loader-wrapper [loading]="showLoading" [messageKey]="loadingMessage">
          <ng-container *ngTemplateOutlet="mainTemplateRef"></ng-container>
        </app-loader-wrapper>
      </section>
      @if (footerTemplateRef) {
        <app-main-footer [templateRef]="footerTemplateRef" [hideFooter]="hideFooter"></app-main-footer>
      }
    </section>
  </mat-sidenav-content>
</mat-sidenav-container>
